import React from 'react';

const StoryLayout = (props) => {
  return (
    <>
      <section  className="d-flex vw-100 m-0 p-0">
            { React.cloneElement(props.children) }
      </section>
    </>
  );
}

export default StoryLayout;

